import {fetchData} from '@/shared/api/fetchData.js';

export function createCompositionApi(settings) {
    if (!settings) {
        throw new Error('Settings object is required');
    }

    // The Composition API is part of the leerplatform API (ADR 0003).
    const {apiUrl: url, portalIdentifier, headers} = settings;

    if (!url) {
        throw new Error('apiUrl is required in settings');
    }

    if (!portalIdentifier) {
        throw new Error('portalIdentifier is required in settings');
    }

    /**
     * Request an export of a catalog item (composition or learning plan) including its contents.
     * The endpoint does not return the file itself, but a short-lived, pre-authenticated
     * blob-storage download URL the browser can be sent to directly.
     * @param {string} targetId - The target id of the catalog item to export.
     * @param {string} [exportPortalIdentifier] - Portal identifier, defaults to the configured one.
     * @returns {Promise<{downloadUrl: string, fileName: string, expiresAt: ?string, sizeBytes: number}>}
     */
    async function exportCatalogItem(targetId, exportPortalIdentifier = portalIdentifier) {
        if (!targetId) throw new Error('targetId is required');

        // Let errors propagate so the caller can distinguish a 404 (nothing to export)
        // from a generic failure. The blob download itself happens outside this wrapper.
        return await fetchData(
            `${url}/api/1.0/composition/export/${exportPortalIdentifier}/${targetId}`,
            {
                method: 'POST',
                headers,
            },
        );
    }

    return {
        exportCatalogItem,
    };
}
